//
// Copyright (c) 2025 Comcast
//

import colors from 'components/utils/colors'

export const REQUEST_METHOD_COLOR_MAP = {
  'GET': colors.info70,
  'POST': colors.success30,
  'PUT': colors.success30,
  'PATCH': colors.warning40,
  'DELETE': colors.alert40,
}

export const REQUEST_METHOD_BADGE_COLOR_MAP = {
  'GET': colors.info80,
  'POST': colors.success73,
  'PUT': colors.success90,
  'PATCH': colors.paused80,
  'DELETE': colors.alert85,
}

export const REQUEST_DIRECTION_COLOR_MAP = {
  'inbound': colors.success73,
  'outbound': colors.info80,
}

export const SUBSCRIPTION_STATUS_COLOR_MAP = {
  'success': colors.success73,
  'failed': colors.alert85,
}

export const SAT_COMPLIANCE_STATUS_COLOR_MAP = {
  'compliant': colors.success73,
  'soon_out_of_compliance': colors.warning80,
  'out_of_compliance': colors.alert85,
  'not_used': colors.pausedGray,
  'disabled': colors.success73,
}

export const ACTION_COLOR_MAP = {
  'create': colors.success30,
  'update': colors.warning50,
  'collection': colors.info55,
}

export const CHART_SERIES_COLOR_MAP = {
  'bonded': colors.success53,
  'unbonded': colors.alert70,
  'open': colors.success53,
  'closed': colors.alert70,
}

export const HIGHCHART_SERIES_COLORS = [
  colors.info70,
  colors.warning60,
  '#E8B931',
  '#4FC1AD',
]

export const HTTP_CODES_COLORS_MAP = {
  '2xx': [
    colors.success53,
    colors.success73,
    colors.success45,
    colors.success63,
  ],
  '4xx': [
    colors.alert70,
    colors.alert85,
    colors.alert65,
    colors.alert75,
  ],
  '5xx': [
    colors.alert70,
    colors.alert85,
    colors.alert65,
    colors.alert75,
  ],
}

export const RESPONSE_STATUS_COLORS_MAP = {
  'success': colors.success73,
  'failed': colors.alert85,
}

export const STATUS_COLORS = [
  '#E6ACAC', '#F7BBC1', '#F5A6C3', '#FFCEC7', '#C0E7D0', '#C5E79D', '#CDDA9A',
  '#E6F797', '#EBE695', '#F5E0A3', '#F7EF98', '#BFD6F2', '#C0C8E7', '#CFB5E3',
]

export const AUDIT_ACTION_COLOR_MAP = {
  'create': colors.success45,
  'destroy': colors.alert65,
  'update': colors.info55,
}

export const FEEDBACK_STATUS_COLOR_MAP = {
  'new': colors.info80,
  'approved': colors.success73,
  'rejected': colors.alert85,
}

export const FEEDBACK_COLOR_MAP = {
  'positive': colors.success45,
  'neutral': colors.paused47,
  'negative': colors.alert65,
}

export const EMAILS_ACTION_TYPE_COLOR_MAP = {
  'privileged_user_signed_in': colors.alert85,
  'feedback': colors.paused65,
  'unbonded_tickets': colors.mint,
  'unbonded_tickets_new': colors.mint,
  'updated_tickets': colors.info80,
  'updated_tickets_new': colors.info80,
  'new_tickets': colors.success73,
  'new_tickets_new': colors.success73,
  'published_release': colors.warning80,
}

export const WEBHOOK_EVENTS_STATE_COLOR_MAP = {
  'pending': colors.info80,
  'processing': colors.warning,
  'successful': colors.resolved,
  'failed': colors.alert65,
  'in_retry': colors.alert85,
  'duplicate': colors.warning80,
  'ignored': colors.pausedGray,
}

export const WEBHOOK_EVENTS_ACTION_TYPE_COLOR_MAP = {
  'create_ticket': colors.success73,
  'update_ticket': colors.info80,
  'create_comment': colors.paused65,
  'create_attachment': colors.mint,
}

export const TICKET_TYPES_COLOR_MAP = {
  'Epic': colors.bgStatus7,
  'User Story': colors.bgStatus14,
  'Task': colors.bgStatus12,
  'Sub-Task': colors.bgStatus10,
  'Bug': colors.bgStatus2,
  'Invalid Type': colors.alert85,
}
